import { Button, Select, message } from 'antd'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom';
import { catchError } from '../../utils/errorHandler';
import axiosInstance from '../../services/axiosInstance';

const EditCanSendSolutionWithoutPayment = ({ fetchOrderDetails, handleModalClose }) => {
    const [selectedFields, setSelectedFields] = useState(null);
    const [loading, setLoading] = useState(false)
    const { orderKey } = useParams()

    const handleSelectChange = (value) => {
        setSelectedFields(value)
    }

    const handleSubmit = async () => {
        setLoading(true)
        try {
            const response = await axiosInstance.post(`task/v2/edit-send-without-payment/${orderKey}/`, {
                can_send_without_payment: selectedFields
            })
            console.log("res", response)
            if (response.status === 200) {
                if (response?.data?.status === "success") {
                    message.success(response?.data?.data)
                    handleModalClose()
                    fetchOrderDetails()
                }
            }
            setLoading(false)
            setSelectedFields(null)

        } catch (err) {
            await catchError(err)
            setLoading(false)
            setSelectedFields(null);
        }
    }

    return (
        <div>

            <div style={{ marginBottom: "10px" }}>Select fields</div>
            <Select
                style={{ width: '100%' }}
                placeholder="Select Yes / No"
                onChange={handleSelectChange}
                value={selectedFields}
            >
                <Select.Option value="true">Yes</Select.Option>
                <Select.Option value="false">No</Select.Option>
            </Select>
            <div style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}>
                <Button className='handle_submit_action_button' onClick={handleSubmit} >{loading ? "Loading..." : "Submit"}</Button>
            </div>
        </div>
    )
}

export default EditCanSendSolutionWithoutPayment